import { Component, input } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-page-section',
  template: `
    <section
      class="relative z-20"
      [ngClass]="{
        'py-8 md:py-10 lg:py-16': padding() === 'sm',
        'py-10 md:py-20 lg:py-28': padding() === 'base',
        'py-16 md:py-28 lg:py-40': padding() === 'lg',
        'bg-neutral-100': backgroundColor() === 'neutral',
        'bg-secondary-500': backgroundColor() === 'secondary',
        'section-header': headerBackground(),
        'section-header-left': headerBackground() === 'left',
        'section-header-right': headerBackground() === 'right',
      }"
    >
      <div [ngClass]="{ container: !noContainer() }">
        @if (waves()) {
          <div class="custom-shape-divider-top-1711102075">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                class="shape-fill"
              ></path>
            </svg>
          </div>
          <div class="pt-10 md:pb-0"></div>
        }

        @if (offsetImage()) {
          <img
            class="absolute -top-6 left-2/3 z-2 w-28 md:-top-20 md:w-52"
            ngSrc="{{ offsetImage() }}"
            width="208"
            height="208"
          />
        }

        <ng-content></ng-content>

        @if (waves()) {
          <div class="pt-10 md:pb-0"></div>
          <div class="custom-shape-divider-bottom-1655373034">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                class="shape-fill"
              ></path>
            </svg>
          </div>
        }
      </div>
    </section>

    @if (headerBackgroundBottomSeparator()) {
      <div [ngClass]="{ container: !noContainer() }">
        <div class="hidden h-px bg-secondary-500 lg:block"></div>
      </div>
    }
  `,
  imports: [NgClass, NgOptimizedImage],
  styles: [
    `
      .custom-shape-divider-top-1711102075 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        line-height: 0;
        transform: rotate(180deg);
      }

      .custom-shape-divider-top-1711102075 svg {
        position: relative;
        display: block;
        width: calc(300% + 1.3px);
        height: 67px;
      }

      .custom-shape-divider-top-1711102075 .shape-fill {
        fill: #ffffff;
      }

      .custom-shape-divider-bottom-1655373034 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        line-height: 0;
      }

      .custom-shape-divider-bottom-1655373034 svg {
        position: relative;
        display: block;
        width: calc(100% + 1.3px);
        height: 17px;
      }

      .custom-shape-divider-bottom-1655373034 .shape-fill {
        fill: #ffffff;
      }

      @media only screen and (min-width: theme('screens.lg')) {
        .section-header::before {
          content: '';
          position: absolute;
          top: -100px; /* Aligné sous la navbar */
          width: 750px;
          height: calc(
            100% + 100px
          ); /* Hauteur de la section + l'offset négatif */
          background-size: cover; /* Remplit bien toute la hauteur */
          background-repeat: no-repeat;
          z-index: -1;
        }

        .section-header.section-header-left::before {
          left: 0;
          background-image: url('/assets/img/bg-primary-left.svg');
          background-position: bottom; /* Assure que l’image colle bien au bas */
        }

        .section-header.section-header-right::before {
          right: 0;
          background-image: url('/assets/img/bg-primary-right.svg');
          background-position: right bottom; /* Pour qu'elle colle bien */
        }
      }
    `,
  ],
})
export class PageSectionComponent {
  padding = input<'none' | 'sm' | 'base' | 'lg'>('base');
  noContainer = input<boolean>();
  backgroundColor = input<'white' | 'neutral' | 'secondary'>('white');
  waves = input<boolean>();
  headerBackground = input<'left' | 'right'>();
  headerBackgroundBottomSeparator = input<boolean>();
  offsetImage = input<string | null>();
}
